module.exports = __webpack_public_path__ + "img/multiLanguage.16cd68a4.svg";